const appointmentTime = [
  {
    time: "9:00 AM - 9:30 AM",
    id: 1,
  },
  {
    time: "9:30 AM - 10:00 AM",
    id: 2,
  },
  {
    time: "10:00 AM - 10:30 AM",
    id: 3,
  },
  {
    time: "10:30 AM - 11:00 AM",
    id: 4,
  },
  {
    time: "11:00 AM - 11:30 AM",
    id: 5,
  },
  {
    time: "11:30 AM - 12:00 PM",
    id: 6,
  },
  {
    time: "12:00 PM - 12:30 PM",
    id: 7,
  },
  {
    time: "12:30 PM - 1:00 PM",
    id: 8,
  },
  {
    time: "1:00 PM - 1:30 PM",
    id: 9,
  },
  {
    time: "1:30 PM - 2:00 PM",
    id: 10,
  },
  {
    time: "2:00 PM - 2:30 PM",
    id: 11,
  },
  {
    time: "2:30 PM - 3:00 PM",
    id: 12,
  },
  {
    time: "3:00 PM - 3:30 PM",
    id: 13,
  },
  {
    time: "3:30 PM - 4:00 PM",
    id: 14,
  },
];
const specialityData = [
  {
    speciality: "Consultant Physician",
    id: 1,
  },
  {
    speciality: "Consultant Pathologist",
    id: 2,
  },
  {
    speciality: "Dental Consultant",
    id: 3,
  },
  {
    speciality: "Consultant Surgeon",
    id: 4,
  },
  {
    speciality: "Visiting Consultant",
    id: 5,
  },
  {
    speciality: "Others",
    id: 6,
  },
];

export { appointmentTime, specialityData };
